import SwaggerClient from 'swagger-client'
import {service} from "@/components/mock/base/const.js";
import {requestComponent} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import {coStatus} from "@/components/mock/base/const.js";
import { requestStatus } from "@/components/mock/base/const.js";
import { cpapRequestStatus } from "@/components/mock/base/const.js";
import { machineStatus } from "@/components/mock/base/const.js";
import { cpapManagementStatus } from "@/components/mock/base/const.js";
import { cpapPrescription } from "@/components/mock/base/const.js";
import { inc } from 'semver';

const holiday_jp = require("@holiday-jp/holiday_jp");
const philipsHolidays = require('@/components/mock/base/philipsHollday.json')
const encoding  = require("encoding-japanese");
const validator = require('validator')

export default {
  methods: {
    getUrlManual: function(){
      return location.origin + "/terms/manual.pdf";
    },
    getUrlDealerManual: function(){
      return location.origin + "/terms/dealer_manual.pdf";
    },
    getUrlRentalCondition: function(){
      return location.origin + "/terms/rentalCondition.pdf";
    },
    getUrlPrivacyPolicy: function(){
      return location.origin + "/terms/privacypolicy.pdf";
    },
    getUrlCatalog: function() {
      return location.origin + "/terms/フィリップスのデジタルソリューションのご紹介.pdf";
    },
    ///////////////////////////////////////
    //
    // sessionStorageデータ取得処理
    //
    ///////////////////////////////////////
    getUserInfo: function() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    },
    ///////////////////////////////////////
    //
    // オフィスマスターデータ取得処理
    //
    ///////////////////////////////////////
    getSalesOfficeMaster: function() {
      return JSON.parse(sessionStorage.getItem('salesOfficeMaster'));
    },
    getBranchOfficeMaster: function() {
      return JSON.parse(sessionStorage.getItem('branchOfficeMaster'));
    },
    getBlockMaster: function() {
      return JSON.parse(sessionStorage.getItem('blockMaster'));
    },
    getOfficeMaster: async function(){
      if(!this.getSalesOfficeMaster()){
        await this.callSyncApi(
          true,
          function(client){
            return client.apis.apiCommon.getSalesOfficeListPOST({
              body:{}
            });
          },
          function(result) {
              var salesOfficeMaster = [];
              var branchOfficeMaster = [];
              var blockMaster = [];
              for (var i = 0; i < result.obj.length; i++) {
                salesOfficeMaster.push({
                  code: result.obj[i].salesOfficeCode,
                  name: result.obj[i].salesOfficeName,
                  address: result.obj[i].officeAddress,
                });
                let branchOfficeInfo = branchOfficeMaster.find(branchOffice => {
                  return branchOffice.code == result.obj[i].branchCode;
                });
                if(branchOfficeInfo){
                  branchOfficeInfo.addressList.push(result.obj[i].officeAddress)
                } else {
                  branchOfficeMaster.push({
                    code: result.obj[i].branchCode,
                    name: result.obj[i].branchName,
                    addressList:[result.obj[i].officeAddress]
                  })
                }
                let blockInfo = blockMaster.find(brock => {
                  return brock.code == result.obj[i].blockCode;
                });
                if(!blockInfo) {
                  blockMaster.push({
                    code: result.obj[i].blockCode,
                    name: result.obj[i].blockName,
                  });
                }
              }
              sessionStorage.setItem('salesOfficeMaster', JSON.stringify(salesOfficeMaster));
              sessionStorage.setItem('branchOfficeMaster', JSON.stringify(branchOfficeMaster));
              sessionStorage.setItem('blockMaster', JSON.stringify(blockMaster));
          },
          function(error){
            console.log(error);
          }
        );
      }
    },
    ///////////////////////////////////////
    //
    // 権限マスターデータ取得処理
    //
    ///////////////////////////////////////
    getAuthorityMaster: function() {
      return JSON.parse(sessionStorage.getItem('authorityMaster'));
    },
    getAuthMaster: async function(){
      if(!this.getAuthorityMaster()){
        await this.callSyncApi(
          true,
          function(client){
            return client.apis.apiCommon.getAuthorityListPOST({
              body:{}
            });
          },
          function(result) {
              var authorityMaster = [];
              for (var i = 0; i < result.obj.length; i++) {
                authorityMaster.push({
                  code: result.obj[i].authorityCode,
                  name: result.obj[i].authorityName,
                  type: result.obj[i].authorityType,
                });
              }
              sessionStorage.setItem('authorityMaster', JSON.stringify(authorityMaster));
          },
          function(error){
            console.log(error);
          }
        );
      }
    },
    ///////////////////////////////////////
    //
    // 状態、進捗データ取得処理
    //
    ///////////////////////////////////////
    getStatusList: function(){
      let ret = [];
      let statusMaster =  JSON.parse(sessionStorage.getItem('statusMaster'));
      for(let status of statusMaster){
        let codes = null;
        for( let i = 0; i < ret.length; i++){
          if(ret[i].name == status.statusName){
            codes = ret[i];
            break;
          }
        }
        if(codes){
          codes.code.push(status.statusCode);
        } else {
          ret.push({code: [status.statusCode], name:status.statusName});
        }
      }
      for (let val of ret) {
        val.code = JSON.stringify(val.code)
      }
      return ret;
    },
    getCpapStatusList: function () {
      let ret = [];
      let statusMaster = JSON.parse(sessionStorage.getItem('cpapStatusMaster'));
      for (let status of statusMaster) {
        let codes = null;
        for (let i = 0; i < ret.length; i++) {
          if (ret[i].name == status.statusName) {
            codes = ret[i];
            break;
          }
        }
        if (codes) {
          codes.code.push(status.statusCode);
        } else {
          ret.push({ code: [status.statusCode], name: status.statusName });
        }
      }
      for (let val of ret) {
        val.code = JSON.stringify(val.code)
      }
      return ret;
    },
    getStatus: function(value){
      let statusMaster =  JSON.parse(sessionStorage.getItem('statusMaster'));
      return statusMaster.find((item) => {return value == item.statusCode;}).statusName;
    },
    getCpapStatus: function (value) {
      let statusMaster = JSON.parse(sessionStorage.getItem('cpapStatusMaster'));
      return statusMaster.find((item) => { return value == item.statusCode; }).statusName;
    },
    getStatusCode: function(status){
      let statusMaster =  JSON.parse(sessionStorage.getItem('statusMaster'));
      return statusMaster.find((item) => {return status == item.statusName;}).statusCode;
    },
    getProgressList: function(){
      let ret = [];
      let statusMaster =  JSON.parse(sessionStorage.getItem('statusMaster'));
      for(let status of statusMaster){
        let codes = null;
        for( let i = 0; i < ret.length; i++){
          if(ret[i].name == status.progressName){
            codes = ret[i];
            break;
          }
        }
        if(codes){
          codes.code.push(status.statusCode);
        } else {
          ret.push({code: [status.statusCode], name:status.progressName});
        }
      }
      for (let val of ret) {
        val.code = JSON.stringify(val.code)
      }
      return ret;
    },
    getCpapProgressList: function () {
      let ret = [];
      let statusMaster = JSON.parse(sessionStorage.getItem('cpapStatusMaster'));
      for (let status of statusMaster) {
        let codes = null;
        for (let i = 0; i < ret.length; i++) {
          if (ret[i].name == status.progressName) {
            codes = ret[i];
            break;
          }
        }
        if (codes) {
          codes.code.push(status.statusCode);
        } else {
          ret.push({ code: [status.statusCode], name: status.progressName });
        }
      }
      for (let val of ret) {
        val.code = JSON.stringify(val.code)
      }
      return ret;
    },
    getProgres: function(value){
      let statusMaster =  JSON.parse(sessionStorage.getItem('statusMaster'));
      return statusMaster.find((item) => {return value == item.statusCode;}).progressName;
    },
    getCpapProgres: function (value, kind) {
      if (kind == 4 && value == 14) {
        return "完了(転院先確定)"
      }
      let statusMaster = JSON.parse(sessionStorage.getItem('cpapStatusMaster'));
      return statusMaster.find((item) => { return value == item.statusCode; }).progressName;
    },
    getProgressValue: function(progress){
      let statusMaster =  JSON.parse(sessionStorage.getItem('statusMaster'));
      let ret = [];
      for(let status of statusMaster){
        if(status.progressName == progress){
          ret.push(status.statusCode);
        }
      }
      return ret;
    },
    getShippingStatusList: function () {
      let ret = [];
      let statusMaster = JSON.parse(sessionStorage.getItem('statusMaster'));
      for (let status of statusMaster) {
        let codes = null;
        if (!status.shippingStatus) continue
        for (let i = 0; i < ret.length; i++) {
          if (ret[i].name == status.shippingStatus) {
            codes = ret[i];
            break;
          }
        }
        if (codes) {
          codes.code.push(status.statusCode);
        } else {
          ret.push({ code: [status.statusCode], name: status.shippingStatus });
        }
      }
      for (let val of ret) {
        val.code = JSON.stringify(val.code)
      }
      return ret;
    },
    getShipping: function (value) {
      let statusMaster = JSON.parse(sessionStorage.getItem('statusMaster'));
      return statusMaster.find((item) => { return value == item.statusCode; }).shippingStatus;
    },
    getAnalysisStatusList: function () {
      let ret = [];
      let statusMaster = JSON.parse(sessionStorage.getItem('statusMaster'));
      for (let status of statusMaster) {
        let codes = null;
        if (!status.analysisStatus) continue
        for (let i = 0; i < ret.length; i++) {
          if (ret[i].name == status.analysisStatus) {
            codes = ret[i];
            break;
          }
        }
        if (codes) {
          codes.code.push(status.statusCode);
        } else {
          ret.push({ code: [status.statusCode], name: status.analysisStatus });
        }
      }
      for (let val of ret) {
        val.code = JSON.stringify(val.code)
      }
      return ret;
    },
    getAnalysis: function (value) {
      let statusMaster = JSON.parse(sessionStorage.getItem('statusMaster'));
      return statusMaster.find((item) => { return value == item.statusCode; }).analysisStatus;
    },
    getStatusMaster: async function(){
      await this.callSyncApi(
        true,
        function(client){
          return client.apis.apiCommon.getStatusListPOST({
            body:{}
          });
        },
        function(result) {
          var statusMaster = [];
          for (var i = 0; i < result.obj.length; i++) {
            statusMaster.push({
              statusCode: result.obj[i].statusCode,
              statusName: result.obj[i].statusName,
              progressName: result.obj[i].progressName,
              shippingStatus: result.obj[i].shippingStatus,
              analysisStatus: result.obj[i].analysisStatus,
            });
          }
          sessionStorage.setItem('statusMaster', JSON.stringify(statusMaster));
        },
        function(error){
          console.log(error);
        }
      );
    },
    getCpapStatusMaster: async function () {
      await this.callSyncApi(
        true,
        function (client) {
          return client.apis.apiCommon.getCpapStatusListPOST({
            body: {}
          });
        },
        function (result) {
          var statusMaster = [];
          for (var i = 0; i < result.obj.length; i++) {
            statusMaster.push({
              statusCode: result.obj[i].statusCode,
              statusName: result.obj[i].statusName,
              progressName: result.obj[i].progressName
            });
          }
          sessionStorage.setItem('cpapStatusMaster', JSON.stringify(statusMaster));
        },
        function (error) {
          console.log(error);
        }
      );
    },
    ///////////////////////////////////////
    //
    // 検査種別マスター取得処理
    //
    ///////////////////////////////////////
    getKindList: function(){
      let ret = [];
      let kindMaster =  JSON.parse(sessionStorage.getItem('kindMaster'));
      for(let kind of kindMaster){
        ret.push({value: kind.value, label:kind.label1});
      }
      return ret;  
    },
    getKind: function(value){
      let kindMaster =  JSON.parse(sessionStorage.getItem('kindMaster'));
      let target =  kindMaster.find((item) => {return value == item.value;});
      return target ? target.label1: "";
    },
    getKindValue: function(kind){
      let kindMaster =  JSON.parse(sessionStorage.getItem('kindMaster'));
      let target =  kindMaster.find((item) => {return kind == item.label1;});
      return target ? target.value: "";
    },
    getKindGroup: function() {
      let ret = [];
      let kindMaster  =  JSON.parse(sessionStorage.getItem('kindMaster'));
      for(let kind of kindMaster){
        let kindItem = null;
        for( let i = 0; i < ret.length; i++){
          if(ret[i].label == kind.label2){
            kindItem = ret[i];
            break;
          }
        }
        if(kindItem){
          kindItem.value.push(kind.value);
        } else {
          ret.push({ value: [kind.value], label: kind.label2});
        }
      }
      for (let val of ret) {
        val.value = JSON.stringify(val.value)
      }
      return ret;
    },
    getKindGroupLabel: function(value){
      let kindMaster =  JSON.parse(sessionStorage.getItem('kindMaster'));
      let targ = kindMaster.find((item) => {return value == item.value;});
      return targ ? targ.label2 : "";
    },
    getKindGroupValue: function(kindGroup){
      let kindMaster =  JSON.parse(sessionStorage.getItem('kindMaster'));
      let ret = [];
      for(let kind of kindMaster){
        if(kind.label2 == kindGroup){
          ret.push(kind.value);
        }
      }
      return ret;
    },
    getKindMaster: async function(){
      await this.callSyncApi(
        true,
        function(client){
          return client.apis.apiCommon.getInspectionKindListPOST({
            body:{}
          });
        },
        function(result) {
          var kindMaster = [];
          for (var i = 0; i < result.obj.length; i++) {
            kindMaster.push({
              value: result.obj[i].value,
              label1: result.obj[i].label1,
              label2: result.obj[i].label2,
            });
          }
          sessionStorage.setItem('kindMaster', JSON.stringify(kindMaster));
        },
        function(error){
          console.log(error);
        }
      );
    },
    ///////////////////////////////////////
    //
    // CPAP各種共通マスター取得処理
    //
    ///////////////////////////////////////
    getCpapCodeMaster: function () {
      return JSON.parse(sessionStorage.getItem('cpapCodeMaster'));
    },
    getCpapPatientStatusList: function () {
      let ret = [];
      let cpapPatientStatusMaster = JSON.parse(sessionStorage.getItem('cpapPatientCodeStatusMaster'));
      for (let item of cpapPatientStatusMaster) {
        ret.push({ code: item.code, name: item.name });
      }
      return ret;
    },
    getCpapPatientProgressList: function () {
      let ret = [];
      let statusMaster = JSON.parse(sessionStorage.getItem('cpapPatientCodeStatusMaster'));
      for (let status of statusMaster) {
        let codes = null;
        for (let i = 0; i < ret.length; i++) {
          if (ret[i].name == status.progressName) {
            codes = ret[i];
            break;
          }
        }
        if (codes) {
          codes.code.push(status.code);
        } else {
          ret.push({ code: [status.code], name: status.progressName });
        }
      }
      for (let val of ret) {
        val.code = JSON.stringify(val.code)
      }
      return ret;
    },
    getCpapPatientCodeStatus: function (value) {
      let cpapPatientCodeMaster = JSON.parse(sessionStorage.getItem('cpapPatientCodeStatusMaster'));
      let target = cpapPatientCodeMaster.find((item) => { return value == item.code; });
      return target ? target.name : "";
    },
    getCpapKindList: function (flg) {
      let ret = [];
      let cpapKindMaster = JSON.parse(sessionStorage.getItem('cpapKindMaster'));
      if (flg) {
        cpapKindMaster = JSON.parse(sessionStorage.getItem('cpapKindMasterForSearch'));
      }
      if (!cpapKindMaster) return ret;
      for (let item of cpapKindMaster) {
        ret.push({ code: item.code, name: item.name });
      }
      return ret;
    },
    getCpapKind: function (value) {
      let kindMaster = JSON.parse(sessionStorage.getItem('cpapKindMaster'));
      let target = kindMaster.find((item) => { return value == item.code; });
      return target ? target.name : "";
    },
    getCpapManagementStatusList: function () {
      let ret = [];
      let cpapStatusMaster = JSON.parse(sessionStorage.getItem('cpapManagementStatus'));
      if (!cpapStatusMaster) return ret;
      for (let item of cpapStatusMaster) {
        ret.push({ code: item.code, name: item.name });
      }
      return ret;
    },
    getCpapManagementStatus: function (value) {
      let cpapStatusMaster = JSON.parse(sessionStorage.getItem('cpapManagementStatus'));
      let target = cpapStatusMaster.find((item) => { return value == item.code; });
      return target ? target.name : "";
    },
    getCpapCommonMaster: async function () {
      await this.callSyncApi(
        true,
        function (client) {
          return client.apis.apiCommon.getCpapCommonListPOST({
            body: {}
          });
        },
        function (result) {
          sessionStorage.setItem('cpapKindMaster', JSON.stringify(result.obj.kindMaster));
          sessionStorage.setItem('cpapKindMasterForSearch', JSON.stringify(result.obj.kindMasterForSearch));
          sessionStorage.setItem('cpapPatientCodeStatusMaster', JSON.stringify(result.obj.patientCodeStatusMaster));
          sessionStorage.setItem('cpapCodeMaster', JSON.stringify(result.obj.cpapCodeMaster));
          sessionStorage.setItem('cpapManagementStatus', JSON.stringify(result.obj.managementStatus));
        },
        function (error) {
          console.log(error);
        }
      );
    },
    ///////////////////////////////////////
    //
    // 選択肢リストマスターの取得
    //
    ///////////////////////////////////////
    getChoiceList: function(choiceType, includeDeleted){
      let choiceMaster =  JSON.parse(sessionStorage.getItem('choiceMaster'));
      let ret = choiceMaster.find((val) => {
        return choiceType == val.choicesType
      });
      ret = ret.choicesList.filter((val) => {
        if(includeDeleted){
          return true;
        } else {
          return val.deleteFlag != true;
        }
      });
      return ret;
    },
    getChoiceMaster: async function(){
      await this.callSyncApi(
        true,
        function(client){
          return client.apis.apiCommon.getChoicesListPOST({
            body:{}
          });
        },
        function(result) {
          sessionStorage.setItem('choiceMaster', JSON.stringify(result.obj));
        },
        function(error){
          console.log(error);
        }
      );
    },
    ///////////////////////////////////////
    //
    // CPAP機種データ取得処理
    //
    ///////////////////////////////////////
    getCpapMaster: function () {
      let ret = [];
      let modelMaster = JSON.parse(sessionStorage.getItem('cpapMaster'));
      if (!modelMaster) return modelMaster
      for (let model of modelMaster) {
        model.itemCodes = JSON.stringify(model.itemCodes)
      }
      return modelMaster;
    },
    getCpapName: function (value) {
      let cpapMaster =  JSON.parse(sessionStorage.getItem('cpapMaster'));
      let target = cpapMaster.find((item) => { return value == item.itemCode; });
      return target ? target.itemName : "";
    },
    getPrescriptionHardware: async function () {
      if (!this.getCpapMaster()) {
        await this.callSyncApi(
          true,
          function (client) {
            return client.apis.apiCommon.getPrescriptionHardwarePOST({
              body: {}
            });
          },
          function (result) {
            var cpapMaster = [];
            for (var i = 0; i < result.obj.length; i++) {
              cpapMaster.push({
                itemCode: result.obj[i].itemCode,
                itemName: result.obj[i].itemName,
                itemCodes: result.obj[i].itemCodes,
                items: result.obj[i].items,
                reportFormatType: result.obj[i].reportFormatType,
              });
            }
            sessionStorage.setItem('cpapMaster', JSON.stringify(cpapMaster));
          },
          function (error) {
            console.log(error);
          }
        );
      }
    },
    ///////////////////////////////////////
    //
    // CPAP品目データ取得処理(付属品、標準品目)
    //
    ///////////////////////////////////////
    getCpapStandardList: function () {
      return JSON.parse(sessionStorage.getItem('cpapStandardList'));
    },
    getCpapAccessoryList: function () {
      return JSON.parse(sessionStorage.getItem('cpapAccessoryList'));
    },
    getCpapSetItemList: function () {
      return JSON.parse(sessionStorage.getItem('cpapSetItemList'));
    },
    getCpapItemMaster: async function () {
      await this.callSyncApi(
        true,
        function (client) {
          return client.apis.apiCommon.getCpapItemMasterPOST({
            body: {}
          });
        },
        function (result) {
          sessionStorage.setItem('cpapStandardList', JSON.stringify(result.obj.standardList));
          sessionStorage.setItem('cpapAccessoryList', JSON.stringify(result.obj.accessoryList));
          sessionStorage.setItem('cpapSetItemList', JSON.stringify(result.obj.setItemList));
        },
        function (error) {
          console.log(error);
        }
      );
    },
    ///////////////////////////////////////
    //
    // コピーオブジェクト取得
    //
    ///////////////////////////////////////
    getCopy: function(object){
      return JSON.parse(JSON.stringify(object));
    },
    /////////////////////////////////////
    //
    // SwaggerClient取得処理
    //
    ////////////////////////////////////
    getSwaggerClient: function (bodyJson) {
      var ret = null;
      if (bodyJson) {
        if (!window.waggerClientForJson) {
          window.waggerClientForJson = new SwaggerClient({
            url: '/api-docs',
            requestInterceptor: req => {
              if (req.body) {
                req.headers['Content-Type'] = 'application/json'
              }
              //↓モックの場合は、以下をコメントアウトすること
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            },
            responseInterceptor: res => {
              console.log(res)
            }
          })
        }
        ret = window.waggerClientForJson
      } else {
        if (!window.waggerClient) {
          window.waggerClient = new SwaggerClient({
            url: '/api-docs',
            requestInterceptor: req => {
              //↓モックの場合は、以下をコメントアウトすること
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            },
            responseInterceptor: res => {
              console.log(res)
            }
          })
        }
        ret = window.waggerClient
      }
      return ret;
    },
    /////////////////////////////////////
    //
    // WebAPI実行関数
    //
    ////////////////////////////////////
    /**
     * Web API を実行します。
     * @param {*} executeApi 実行するWebAPIのメソッド
     * @param {*} successCallback 成功時のコールバック関数
     * @param {*} errorCallback 　エラー時のコールバック関数
     */
    apiCall: function (executeApi, successCallback, errorCallback) {
      return this.callApi(true, executeApi, successCallback, errorCallback, true)
    },
    /**
     * Web API を実行します。
     * @param {*} executeApi 実行するWebAPIのメソッド
     * @param {*} successCallback 成功時のコールバック関数
     * @param {*} errorCallback 　エラー時のコールバック関数
     */
    apiAnsyncCall: function (executeApi, successCallback, errorCallback) {
      return this.callApi(true, executeApi, successCallback, errorCallback, false)
    },    
    /**
     * Web API を実行します。(ファイルアップロード系API)
     * @param {*} executeApi 
     * @param {*} successCallback 
     * @param {*} errorCallback 
     */
    uploadApiCall: function (executeApi, successCallback, errorCallback) {
      return this.callApi(false, executeApi, successCallback, errorCallback, true)
    },
    /**
     * Web API を実行します。(ファイルダウンロード系API)
     * @param {*} executeApi 
     * @param {*} errorCallback 
     */
    downloadApiCall: function (executeApi, errorCallback, successCallback2) {
      var successCallback = (result) => {
        console.log(result)
        var name = result.headers['content-disposition'].split('=')[1]
        name = name.slice(name.lastIndexOf('\'') + 1)
        const blob = result.data
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = decodeURI(name)
        link.click()
        if (successCallback2) {
          successCallback2()
        }
      }
      return this.callApi(true, executeApi, successCallback, errorCallback, true)
    },
    /**
     * 2Gを超えるファイルが存在するかどうかのチェック
     */
    checkUploadFileSize: async function(uploadItemInfoList){
      const MAX_NODE_BUFFER_SIZE = 2147000000;
      let ret = true;
      for(let uploadItemIfno of uploadItemInfoList){
        let uploadItem = uploadItemIfno.file;
        const traverseFileTree = async (entry, path) => {
          const _path = path || "";
          if(entry instanceof File){
            if(entry.size > MAX_NODE_BUFFER_SIZE){
              ret = false;
            }
          } else if (entry.isFile) {
            const file = await new Promise((resolve) => {
              entry.file((file) => {
                resolve(file);
              });
            });
            if(file.size > MAX_NODE_BUFFER_SIZE){
              ret = false;
            }
          } else if (entry.isDirectory) {
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve) => {
              directoryReader.readEntries((entries) => {
                resolve(entries);
              });
            });

            for (let i = 0; i < entries.length; i++) {
              await traverseFileTree(entries[i], _path + entry.name + "/"); // 再帰的な関数呼び出し
            }
          }
        };
        // ここでドロップされた最初のディレクトリ（or ファイル）を渡す
        await traverseFileTree(uploadItem);
      }
      return ret;
    },
    /**
     * 
     * @param {*} bodyJson 
     * @param {*} executeApi 
     * @param {*} successCallback 
     * @param {*} errorCallback 
     * @param {*} doLoading 
     * @returns 
     */
    multipleUpload: async function (uploadItemInfoList, receiptNumber, uploadFileType, compressFileName) {
      let successUploadFiles = [];
      var appVue = this.$root.$children[0];
      if(uploadItemInfoList.length < 1){
        return Promise.resolve(successUploadFiles);
      }
      appVue.loadingStart()
      try{
        let identifier = new Date().getTime();
        var uploadFileList = [];
        //ファイルを抽出
        for(let uploadItemIfno of uploadItemInfoList){
          let uploadItem = uploadItemIfno.file;
          // const entry = item.webkitGetAsEntry();  
          // ファイルスキャン関数
          const traverseFileTree = async (entry, path) => {
            const _path = path || "";
            if(entry instanceof File){
              uploadFileList.push({ file: entry, path: _path + entry.name }); // ファイルを取得したらリストにプッシュする
            } else if (entry.isFile) {
              const file = await new Promise((resolve) => {
                entry.file((file) => {
                  resolve(file);
                });
              });
              uploadFileList.push({ file: file, path: _path + file.name }); // ファイルを取得したらリストにプッシュする
            } else if (entry.isDirectory) {
              const directoryReader = entry.createReader();
              let resultEntries = []
              let _this = this
              let read = async function () {
                let entries = await _this.readEntriesAsync(directoryReader);
                if (entries.length > 0) {
                  resultEntries = resultEntries.concat(entries);
                  await read();
                }
              }
              await read();
              for (let i = 0; i < resultEntries.length; i++) {
                await traverseFileTree(resultEntries[i], _path + entry.name + "/"); // 再帰的な関数呼び出し
              }
            }
          };
          // ここでドロップされた最初のディレクトリ（or ファイル）を渡す
          await traverseFileTree(uploadItem);
        }
        if(uploadFileList.length < 1){
          return Promise.resolve(successUploadFiles);
        }
        try{
          //アップロードトランザクション開始
          let uploadId = 0;
          await this.apiAnsyncCall(
            function(client){
              return client.apis.apiCommon.uploadFilePollingStartPOST({body:{receptionNo: receiptNumber}})
            },
            function(result){
              uploadId = result.obj.id;
            },
            function(error){
              throw error;
            }
          );
          let roop = true;
          for(let i = 0; i < uploadFileList.length; i ++){
            if(roop == false){
              break;
            }
            let uploadFile = uploadFileList[i];
            if(i != uploadFileList.length -1){
              console.log("file upload.");
              await this.callSyncApi(
                false,
                function(client){
                  return client.apis.apiCommon.uploadFilePOST({
                          uploadId:uploadId,
                          upfile : uploadFile.file,
                          path : uploadFile.path,
                          receiptNumber:receiptNumber,
                          identifier:identifier
                        })
                },
                function(result){

                },
                function(error){
                  console.log("file upload. error = "  + error);
                  roop = false;
                },
                false
              );
            } else {
              console.log("file last upload.");
              //最後の1ファイルは非同期で呼び出す。
              await this.callSyncApi(
                false,
                function(client){
                  return client.apis.apiCommon.uploadLastFilePOST({
                          uploadId: uploadId,
                          upfile : uploadFile.file,
                          path : uploadFile.path,
                          receiptNumber:receiptNumber,
                          fileType:uploadFileType,
                          identifier:identifier,
                          compressFileName: compressFileName
                        })
                },
                function(result){
                  successUploadFiles = result.obj;
                },
                function(error){ 
                  console.log("file last upload. error = "  + error);
                  roop = false;
                },
                false
              ).catch(error => {
                throw error;
              });
            }
          }
          //終了状況のチェック(ポーリング)
          let nomalFinished = false;
          const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
          while(roop){
            await _sleep(3000); //3秒毎にチェックする
            if(roop){
              await this.apiAnsyncCall(
                function(client){
                  return client.apis.apiCommon.uploadFilePollingCheckPOST({body:{id: uploadId}})
                },
                function(result){
                  if(result.status != 200){
                    console.log(result.statusText);
                    roop = false;
                  } else {
                    let status = result.obj.status;
                    if(status == "success") {
                      console.log("polling success finish.")
                      roop = false;
                      nomalFinished = true;
                    } else if(status == "error"){
                      console.log("polling error finish.")
                      roop = false;
                    } else {
                      console.log("continue polling..." + new Date().getTime());
                    }
                  }
                },
                function(error){
                  console.log(error);
                  throw error;
                }
              );
            }
          }
          if(nomalFinished){
            return Promise.resolve(successUploadFiles);
          } else {
            return Promise.reject("予期しないエラーが発生しました。");
          }
        } catch (e) {
            console.log('error: ', e);
            return Promise.reject(e);
        }
      } finally {
        appVue.loadingEnd();
      }
    },
    readEntriesAsync: async function (reader) {
      return new Promise((resolve, reject) => {
        reader.readEntries(entries => {
          resolve(entries);
        }, error => reject(error));
      })
    },
    callSyncApi: async function (bodyJson, executeApi, successCallback, errorCallback) {
      return new Promise(resolve => {
        this.getSwaggerClient(bodyJson)
          .then(client => {
            // WebAPI Call
            return executeApi(client)
          }).then(result => {
            console.log(result)
            // WebAPI応答内容を画面に設定
            successCallback(result)
            resolve(0)
          }).catch(error => {
            console.log(error)
            var message = '予期しないエラーが発生しました。'
            if (error != null) {
              // サーバから返されたメッセージをダイアログ表示

              if (!error.status) {
                message = error.message
              } else if (error.status === 403) {
                message = "トークンが不正またはタイムアウトしています。再ログインしてください。"
              }
              else if (error.response.body) {
                if (error.response.body.message) {
                  message = error.response.body.message
                } else {
                  message = error.message
                }
              } else {
                message = error.message
              }
              errorCallback(message)
              console.log(message)
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              errorCallback('予期しないエラーが発生しました。')
            }
            resolve(message)
          })
      }).catch(error => {
        console.log(error)
        errorCallback(error)
        resolve(error)
      })
    },

    /**
     * Web API を実行します。（内部呼出しのみ！）
     * @param {*} bodyJson 
     * @param {*} executeApi 
     * @param {*} successCallback 
     * @param {*} errorCallback 
     * @param {*} doLoading 
     */
    callApi: function (bodyJson, executeApi, successCallback, errorCallback, doLoading) {
      var appVue = this.$root.$children[0]  //TODO App.vueの取得方法はこれで合っているか？
      var loadingFlag = true
      // ロード中か判定
      if (appVue.$data.isLoading) {
        loadingFlag = false
      }

      if (doLoading && loadingFlag) {
        appVue.loadingStart()
      }

      return new Promise(resolve => {
        this.getSwaggerClient(bodyJson)
          .then(client => {
            // WebAPI Call
            return executeApi(client)
          }).then(result => {
            console.log(result)
            if (loadingFlag) {
              appVue.loadingEnd()
            }

            // WebAPI応答内容を画面に設定
            successCallback(result)
            resolve()
          }).catch(error => {
            console.log(error)
            if (error != null) {
              // サーバから返されたメッセージをダイアログ表示
              var message = ''
              if (!error.status) {
                message = error.message
              } else if (error.status === 403) {
                message = "トークンが不正またはタイムアウトしています。再ログインしてください。"
              }
              else if (error.response) {
                if(error.response.body){
                  if (error.response.body.message) {
                    message = error.response.body.message
                  } else {
                    message = error.message
                  }
                }
              } else if(error.responseError){
                message = error.responseError.message
              } else {
                message = error.message
              }
              if (loadingFlag) {
                appVue.loadingEnd()
              }
              errorCallback(message)
              console.log(message)
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              errorCallback('予期しないエラーが発生しました。')
              if (loadingFlag) {
                appVue.loadingEnd()
              }
            }
            resolve()
          })
      }).catch(error => {
        console.log(error)
        this.$root.$children[0].loadintEnd()
        errorCallback('予期しないエラーが発生しました。')
        resolve()
      })
    },
    /**
     * API成功時のダイアログメッセージを表示します。
     * @param {*} result 
     */
    showSuccess: async function (result, callback) {
      var resBody = result.obj
      var messageStr = resBody['message']
      if (messageStr.indexOf("\n")) {
        var resultList = messageStr.split("\n");
        for (var i = 0; i < resultList.length; i++) {
          if (i != 0) {
            messageStr = messageStr + "<br>" + resultList[i];
          } else {
            messageStr = resultList[i];
          }
        }
      }
      await this.$dialog.alert({
        title: '　',
        message: messageStr,
        onConfirm: callback
      })
    },
    /**
     * 確認ダイアログメッセージを表示します。
     * @param {*} result 
     */
    showComfirmMessage: async function (messageStr) {
      if (messageStr.indexOf("\n")) {
        const resultList = messageStr.split("\n");
        for (let i = 0; i < resultList.length; i++) {
          if (i != 0) {
            messageStr = messageStr + "<br>" + resultList[i];
          } else {
            messageStr = resultList[i];
          }
        }
      }
      const res = await new Promise((resoleve, reject) => {
        this.$dialog.confirm({
          title: "　",
          message: messageStr,
          onConfirm: () => {
            resoleve();
          },
          onCancel: () => {
            reject();
          }
        });
      }).then(() => {
        return true;
      }).catch(() => {
        return false;
      });

      return await res;
    },
    /**
     * API失敗時のダイアログメッセージを表示します。
     * @param {*} messageStr 
     */
    showErrorMessage: async function (messageStr,callback) {
      if (messageStr.indexOf("\n")) {
        var resultList = messageStr.split("\n");
        for (var i = 0; i < resultList.length; i++) {
          if (i != 0) {
            messageStr = messageStr + "<br>" + resultList[i];
          } else {
            messageStr = resultList[i];
          }
        }
      }
      await this.$dialog.alert({
        title: '　',
        message: messageStr,
        onConfirm: callback
      })
    },
    showMessage: async function (messageStr, callback) {
      await this.$dialog.alert({
        title: '　',
        message: messageStr,
        onConfirm: callback
      })
    },
    /////////////////////////////////////
    //
    // Date<->String変換関数
    //
    ////////////////////////////////////
    yyyy_sla_MM_sla_dd: function (date) {
      if (!date) {
        return date;
      }
      var ret = "yyyy/MM/dd"
      ret = ret.replace(/yyyy/g, ('000' + date.getFullYear()).slice(-4))
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      ret = ret.replace(/dd/g, ('0' + date.getDate()).slice(-2))
      return ret;
    },
    yyyy_hyp_MM_hyp_dd: function (date) {
      if (!date) {
        return date;
      }
      var ret = "yyyy-MM-dd"
      ret = ret.replace(/yyyy/g, ('000' + date.getFullYear()).slice(-4))
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      ret = ret.replace(/dd/g, ('0' + date.getDate()).slice(-2))
      return ret;
    },
    yyyy_sla_MM: function (date) {
      if (!date) {
        return date;
      }
      var ret = "yyyy/MM"
      ret = ret.replace(/yyyy/g, ('000' + date.getFullYear()).slice(-4))
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      return ret;
    },
    yyyy_hyphen_MM: function (date) {
      if (!date) {
        return date;
      }
      var ret = "yyyy-MM"
      ret = ret.replace(/yyyy/g, ('000' + date.getFullYear()).slice(-4))
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      return ret;
    },
    MM_hyp_dd: function (date) {
      if (!date) {
        return date;
      }
      var ret = "MM-dd"
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      ret = ret.replace(/dd/g, ('0' + date.getDate()).slice(-2))
      return ret;
    },
    replace_yyyy_hyp_MM_hyp_dd: function (yyyyMMdd) {
      var ret = ""
      if(yyyyMMdd){
        ret = yyyyMMdd.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
      }
      return ret;
    },
    replaceSlash: function(str) {
      if (!str) {
        return str;
      }
      return str.replaceAll('-', '/');
    },
    /////////////////////////////////////////////]
    //
    // getTag関数
    // 
    //////////////////////////////////////////////
    getTagClass4ExtUserStatus: function(label) {
      var color = "";
      if (label == extUserStatus.tempReg){
        color = "is-success";
      } else if (label == extUserStatus.brunchReview){
        color = "is-warning";
      } else if (label == extUserStatus.registed){
        color = "is-info";
      } else if (label == extUserStatus.addRequest) {
        color = "is-danger";
      }
      return "tag " + color;
    },
    getTagClass4CoInternalUserStatus: function(value) {
      let color = "";
      if (value == coStatus.requestPending) {
        color = "is-warning";
      } else if (value == coStatus.added) {
        color = "is-success";
      } else if (value == coStatus.cancel) {
        color = "is-dark";
      } else if (value == coStatus.requestConfirmed) {
        color = "is-info";
      } else if (value == coStatus.requestCertification){
        color = "is-warning";
      }
      return "tag " + color;
    },
    getTagClass4CoExternalUserStatus: function(value) {
      let color = "";
      if (value == coStatus.requestPending || value == coStatus.requestConfirmed || value == coStatus.requestCertification ) {
        color = "is-warning";
      } else if (value == coStatus.added) {
        color = "is-success";
      } else if (value == coStatus.cancel) {
        color = "is-dark";
      }
      return "tag " + color;
    },
    getTabClass4RequestStatus(value){
      var color = "";
      if (
           value == requestStatus.inspectionRequest 
        || value == requestStatus.analysisRequest 
        || value == requestStatus.kawagoeAcceptance 
        || value == requestStatus.reInspection
        || value == requestStatus.approving
        || value == requestStatus.deposit_regist
        || value == requestStatus.depositMachineReturnWait
        || value == requestStatus.depositMachine
      ){
        color = "is-warning";
      }
      else if (
        value == requestStatus.deviceReady
        || value == requestStatus.shippingReady 
        || value == requestStatus.inspenction
        || value == requestStatus.deviceReturn
        || value == requestStatus.analysisForwarding
        || value == requestStatus.analysis
        || value == requestStatus.resultComfirm
        || value == requestStatus.resultSendReady
        || value == requestStatus.jugdmentRequest
        || value == requestStatus.salesAppropriation
        || value == requestStatus.replaceFile
        || value == requestStatus.dataExtracted
        || value == requestStatus.depositMachineRental
      ) {
        color = "is-info";
      }
      else if(
          value == requestStatus.completion 
       || value == requestStatus.completionAppropriation 
      ) {
        color = "is-success";
      }
      else if(
        value == requestStatus.cancel 
     || value == requestStatus.depositMachineRelease 
        ) {
        color = "is-dark";
      }
      return "tag " + color;
    },
    getTabClass4InternalStatus(value){
      var color = "";
      if (
           value == requestStatus.inspectionRequest 
        || value == requestStatus.analysisRequest 
        || value == requestStatus.kawagoeAcceptance 
        || value == requestStatus.reInspection 
        || value == requestStatus.approving
        || value == requestStatus.depositMachineReturnWait
        || value == requestStatus.deposit_regist
        || value == requestStatus.depositMachine
        ){
        color = "is-warning";
      }
      else if(
           value == requestStatus.jugdmentRequest
        || value == requestStatus.salesAppropriation
        || value == requestStatus.replaceFile
        || value == requestStatus.dataExtracted
      ){
        color = "is-info";
      }
      else if(
           value == requestStatus.deviceReady
        || value == requestStatus.shippingReady
      ){
        color = "is-blue1";
      }
      else if(
           value == requestStatus.inspenction
        || value == requestStatus.depositMachineRental
      ){
        color = "is-blue2";
      }
      else if(
           value == requestStatus.deviceReturn
      ){
        color = "is-blue3";
      }
      else if(
           value == requestStatus.analysisForwarding
      ){
        color = "is-blue4";
      }
      else if(
           value == requestStatus.analysis
      ){
        color = "is-blue5";
      }
      else if(
           value == requestStatus.resultComfirm
        || value == requestStatus.resultSendReady
      ){
        color = "is-blue6";
      }
      else if(
           value == requestStatus.completion 
        || value == requestStatus.completionAppropriation 
      ) {
        color = "is-success";
      }
      else if(
        value == requestStatus.cancel 
     || value == requestStatus.depositMachineRelease 
        ) {
        color = "is-dark";
      }
      return "tag " + color;
    },
    getMachineStatusTagClass: function (value) {
      var color = "";
      if (value == machineStatus.overdue) {
        color = "is-warning";
      } else if (value == machineStatus.available) {
        color = "is-success";
      } else if (value == machineStatus.deviceReady ||
        value == machineStatus.shipping ||
        value == machineStatus.depositDeviceReady ||
        value == machineStatus.depositShipping
        ) {
        color = "is-info";
      } else if (value == machineStatus.cleaning ||
        value == machineStatus.underRepair ||
        value == machineStatus.tempIntroduction) {
        color = "is-warning";
      } else if (value == machineStatus.delete ||
        value == machineStatus.leaseUp ||
        value == machineStatus.scheduledReturned ||
        value == machineStatus.depositScheduledReturned) {
        color = "is-dark";
      }
      return "tag " + color;
    },
    getTagClass: function (value) {
      var color = "";
      if (value == requestStatus.reInspection ||
        value == requestStatus.inspectionRequest) {
        // 検査依頼中
        // 再検査調整中
        color = "is-warning";
      } else if (value == requestStatus.shippingReady) {
        // 出荷準備中
        color = "is-info";
      } else if (value == requestStatus.completion ||
        value == requestStatus.salesAppropriation ||
        value == requestStatus.completionAppropriation ||
        value == requestStatus.inspenction) {
        // 検査中
        // 完了
        // 売上計上中
        // 完了（計上済）
        color = "is-success";
      } else if (value == requestStatus.cancel) {
        // キャンセル
        color = "is-dark";
      } else if (value == requestStatus.kawagoeAcceptance ||
        value == requestStatus.deviceReady ||
        value == requestStatus.deviceReturn ||
        value == requestStatus.replaceFile ||
        value == requestStatus.jugdmentRequest ||
        value == requestStatus.resultComfirm ||
        value == requestStatus.resultSendReady) {
        // 川越受付中
        // 機器準備中
        // 機器受領中
        // 判定依頼中
        // 結果確認中
        // 結果送付待
        // ファイル差し替え
        color = "is-info";
      }
      return "tag " + color;
    },
    getHstTagClass: function (value) {
      var color = "";
      if (value == requestStatus.inspectionRequest ||
        value == requestStatus.deviceReady ||
        value == requestStatus.shippingReady ||
        value == requestStatus.deposit_regist) {
        // 未出荷
        color = "is-warning";
      } else if (value == requestStatus.inspenction ||
        value == requestStatus.deviceReturn ||
        value == requestStatus.analysisForwarding ||
        value == requestStatus.analysisRequest ||
        value == requestStatus.analysis ||
        value == requestStatus.resultComfirm ||
        value == requestStatus.resultSendReady ||
        value == requestStatus.kawagoeAcceptance ||
        value == requestStatus.jugdmentRequest ||
        value == requestStatus.completion ||
        value == requestStatus.salesAppropriation ||
        value == requestStatus.completionAppropriation ||
        value == requestStatus.reInspection ||
        value == requestStatus.depositMachine ||
        value == requestStatus.depositMachineRental) {
        // 出荷済み
        color = "is-success";
      } else if (value == requestStatus.cancel ||
        value == requestStatus.depositMachineRelease ||
        value == requestStatus.depositMachineReturnWait) {
        // キャンセル
        color = "is-dark";
      }
      return "tag " + color;
    },
    getCpapStatusClass: function (value) {
      var color = "";
      if (value == cpapRequestStatus.request ||
        value == cpapRequestStatus.Approving ||
        value == cpapRequestStatus.approved) {
        color = "is-warning";
      } else if (value == cpapRequestStatus.preparingEquipment ||
        value == cpapRequestStatus.preparingShip ||
        value == cpapRequestStatus.shipped ||
        value == cpapRequestStatus.scheduledreturn ||
        value == cpapRequestStatus.deviceReturn ||
        value == cpapRequestStatus.changeCompleted ||
        value == cpapRequestStatus.equipmentReceipt ||
        value == cpapRequestStatus.tempTakenOut ||
        value == cpapRequestStatus.transferUndecided ||
        value == cpapRequestStatus.kanjadoutaiRequest ||
        value == cpapRequestStatus.returnWait ||
        value == cpapRequestStatus.internalProcessing ||
        value == cpapRequestStatus.untreatedMachineReturned　||
        value == cpapRequestStatus.regularExchangeReturned) {
        color = "is-info";
      } else if (value == cpapRequestStatus.completion) {
        color = "is-success";
      } else if (value == cpapRequestStatus.cancel) {
        color = "is-dark";
      }
      return "tag " + color;
    },
    getCpapPatientStatusClass: function (value) {
      var color = "";
      if (value == cpapManagementStatus.prescription) {
        color = "is-success";
      } else if (value == cpapManagementStatus.undecided) {
        color = "is-warning";
      } else if (value == cpapManagementStatus.transferring || value == cpapManagementStatus.coming) {
        color = "is-info";
      } else if (value == cpapManagementStatus.cancel) {
        color = "is-dark";
      }
      return "tag " + color;
    },
    getCpapInnerStatusClass: function (value) {
      var color = "";
      if (value == cpapRequestStatus.request ||
        value == cpapRequestStatus.Approving ||
        value == cpapRequestStatus.approved) {
        color = "is-warning";
      } else if (value == cpapRequestStatus.preparingEquipment ||
        value == cpapRequestStatus.preparingShip ||
        value == cpapRequestStatus.shipped ||
        value == cpapRequestStatus.deviceReturn ||
        value == cpapRequestStatus.scheduledreturn ||
        value == cpapRequestStatus.changeCompleted ||
        value == cpapRequestStatus.equipmentReceipt ||
        value == cpapRequestStatus.tempTakenOut ||
        value == cpapRequestStatus.transferUndecided ||
        value == cpapRequestStatus.kanjadoutaiRequest ||
        value == cpapRequestStatus.internalProcessing ||
        //20230701 内部指示書ステータス用
        value == cpapRequestStatus.returnWait ||
        value == cpapRequestStatus.untreatedMachineReturned ||
        value == cpapRequestStatus.regularExchangeReturned) {
        color = "is-info";
      } else if (value == cpapRequestStatus.completion) {
        color = "is-success";
      } else if (value == cpapRequestStatus.cancel) {
        color = "is-dark";
      }
      return "tag " + color;
    },
    getShippingTagClass: function (value) {
      var color = "";
      if (value == requestStatus.shippingReady) {
        // 未出荷
        color = "is-warning";
      } else if (value == requestStatus.inspenction || value == requestStatus.depositMachine) {
        // 出荷済み
        color = "is-success";
      } else if (value == requestStatus.cancel) {
        // キャンセル
        color = "is-dark";
      }
      return "tag " + color;
    },
    getHstAnalysisTagClass: function (value) {
      var color = "";
      if (value == requestStatus.deviceReturn ||
        value == requestStatus.reInspection) {
        // 未依頼
        // 再検査調整中
        color = "is-warning";
      } else if (value == requestStatus.analysisForwarding ||
        value == requestStatus.analysisRequest ||
        value == requestStatus.analysis) {
        // 依頼済み
        color = "is-success";
      }
      return "tag " + color;
    },
    getKenshinTagClass: function (value) {
      var color = "";
      if (value == requestStatus.inspectionRequest ||
        value == requestStatus.deviceReady ||
        value == requestStatus.shippingReady ||
        value == requestStatus.kawagoeAcceptance) {
        // 未出荷
        color = "is-warning";
      } else if (value == requestStatus.inspenction ||
        value == requestStatus.deviceReturn ||
        value == requestStatus.analysisForwarding ||
        value == requestStatus.analysisRequest ||
        value == requestStatus.analysis ||
        value == requestStatus.resultComfirm ||
        value == requestStatus.resultSendReady ||
        value == requestStatus.jugdmentRequest ||
        value == requestStatus.completion ||
        value == requestStatus.completion_accounted ||
        value == requestStatus.completion_not_accounted) {
        // 出荷済み
        color = "is-success";
      }
      return "tag " + color;
    },
    getTagClass4PSGApproval: function(label){
      var color = "";
      if (label == "承認済み") {
        color = "is-success";
      } else if (label == "承認依頼中") {
        color = "is-warning";
      } else if (label == "解析承認依頼中") {
        color = "is-warning";
      } else if (label == "ファイル差替中") {
        color = "is-info";
      }
      return "tag " + color;
    },
    getTagClass4HSTAgentLabelPrint: function(label){
      var color = "";
      if (label == "完了（計上済）" || label == "完了" ) {
        color = "is-success";
      } else if (label == "結果送付待ち") {
        color = "is-info";
      }
      return "tag " + color;
    },
    // 不要になったら削除
    getTagclass: function(label) {
      var color = "";
      if (label == "依頼中" || label == "検査依頼中" || label == "解析依頼中" || label == "検診依頼中" || label == "再検査調整中"){
        color = "is-warning";
      } else if (label == "検査中" || label =="機器準備中" || label =="出荷準備中" || label =="検査中" || label =="機器受領中"
              ||label == "解析依頼中" || label =="機器準備中" || label =="出荷準備中" || label =="検査中" || label =="機器受領中"
              ||label == "売上計上中" || label =="出荷予約中"
      ){
        color = "is-info";
      } else if (label == "解析中" || label =="結果確認中"){
        color = "is-info";
      } else if (label == "判定中" || label =="判定依頼中" || label =="結果確認中"|| label =="結果送付待ち"){
        color = "is-info";
      } else if (label == "完了" || label == "完了（計上済）" || label == "完了（DL済）") {
        color = "is-success";
      } else if (label == "キャンセル"){
        color = "is-dark";
      } else if (label == "受領済み") {
        color = "is-success";
      } else if (label == "未返却") {
        color = "is-warning";
      } else if (label == "依頼済み" || label == "承認済み") {
        color = "is-success";
      } else if (label == "未依頼" || label == "承認依頼中") {
        color = "is-warning";
      } else if (label == "利用可能") {
        color = "is-success";
      } else if (label == "貸出中") {
        color = "is-info";
      } else if (label == "クリーニング中" || label == "修理中" || label == "仮導入") {
        color = "is-warning";
      } else if (label == "削除" || label == "リースアップ" || label == "返却予定") {
        color = "is-dark";
      } else if (label == "出荷済み") {
        color = "is-success";
      } else if (label == "未出荷") {
        color = "is-warning";
      } else if (label == "未受付" || label == "出荷日調整中") {
        color = "is-warning";
      } else if (label == "企業検診G受付済" || label == "川越受付済" || label == "返却予定" || label == "機器受領済み" || label == "データ抽出済"
                || label == "判定依頼中" || label == "判定結果作成中") {
        color = "is-info";
      } else if (label == "完了") {
        color = "is-success";
      } else if (label == "申込み中") {
        color = "is-warning";
      }
      return "tag " + color;
    },
    getTagClassTakeupStatus: function(label){
      var color = "";
      if (label == "対象無し") {
        color = "is-warning";
      } else if (label == "本社") {
        color = "is-info";
      } else if (label == "支店") {
        color = "is-success"
      }
      return "tag " + color;
    },
    getClass4ExpirationDate: function(expirationDate){
      let retClass = "";
      if(expirationDate && expirationDate != '' && expirationDate != '－'){
        expirationDate = new Date(expirationDate + " 23:59:59");
        //2ヶ月前
        expirationDate.setMonth(expirationDate.getMonth() - 2);
        let expirationDate3MonthBeforeTime = expirationDate.getTime();        
        let nowDate = new Date().getTime();
        if(expirationDate3MonthBeforeTime < nowDate){
          retClass = "expirationDate";
        }
      }
      return retClass;
    },
    /**
     * 年齢を取得する(日付文字列がyyyy/MM/ddの場合)
     */
    getAge: function(birthdayStr) {
      //誕生日
      var birthday = new Date(birthdayStr);

      //今日
      var today = new Date();

      //今年の誕生日
      var thisYearsBirthday = new Date(today.getFullYear(), birthday.getMonth(), birthday.getDate());

      //年齢
      var age = today.getFullYear() - birthday.getFullYear();

      if(today < thisYearsBirthday){
          //今年まだ誕生日が来ていない
          age--;
      }
      return age;
    },
    /**
     * 和暦を取得する(日付文字列がyyyy/MM/ddの場合)
     */
    getJapaneseCalendar: function (birthdayStr) {
      const date = new Date(birthdayStr);
      const options = { era: 'long' };
      return　new Intl.DateTimeFormat('ja-JP-u-ca-japanese', options).format(date)
    },
  　/**
     * 各申込みの最短出荷可能日を取得する
     */
    getShortestShippingDate() {
      return {
        hst_sp: this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 3)),            // HST(機種がSP)
        hst_athor: this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 2)),         // HST(機種がSP以外)
        kenshin: this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 3)),           // 企業検診
        kenshin_screening: this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 2)), // 企業検診(スクリーニング)
        holter: this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 2))             // ホルター
      }
    },
    //n日後の営業日を取得する
    getBusinessDay: function(baseDay, dayCount){
      var count = 0;
      for(; count < dayCount;){
        baseDay.setDate(baseDay.getDate() + 1);
        if(baseDay.getDay() != 0 && baseDay.getDay() !== 6){ //土日は無視
          if(holiday_jp.between(baseDay, baseDay).length == 0){ //祝日は無視
            var formatedDay = this.MM_hyp_dd(baseDay);
            if(!philipsHolidays.everyyear.includes(formatedDay)){  //年末年始は無視
              formatedDay = this.yyyy_hyp_MM_hyp_dd(baseDay);
              if(!philipsHolidays.irregular.includes(formatedDay)){  //PHILIPS特別休日は無視
                count++;
              }
            }
          }
        }
      }
      return new Date(baseDay.getFullYear(), baseDay.getMonth(), baseDay.getDate());
    },
    getBusinessDayPOST: async function(baseDay, dayCount, cb) {
      var _this = this
      await this.apiCall(
        function(client){
          return client.apis.apiCommon.getBusinessDayPOST({
            body:{
              baseDay: baseDay ? _this.yyyy_hyp_MM_hyp_dd(baseDay) : '',
              dayCount: dayCount
            }
          });
        },
        cb,
        function(error){
          console.log(error);
        }
      );
    },
    //営業日かどうか
    isBusinessDay: function(baseDay){
      if(baseDay.getDay() == 0 || baseDay.getDay() == 6){
        //土日
        return false;
      }
      if(holiday_jp.between(baseDay, baseDay).length != 0){
        //祝日
        return false;
      }
      var formatedDay = this.MM_hyp_dd(baseDay);
      if(philipsHolidays.everyyear.includes(formatedDay)){
        //年末年始
        return false;
      }
      formatedDay = this.yyyy_hyp_MM_hyp_dd(baseDay);
      if(philipsHolidays.irregular.includes(formatedDay)){
        //Philips休日
        return false;
      }
      return true;
    },
    goToTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    jumpToTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "auto"
      });
    },
    enableServiceList: function(serviceId){
      var ret = [];
      for (var serviceValue of Object.values(service)) {
        if(this.isEnableService(serviceId, serviceValue)){
          ret.push(serviceValue)
        }
      }
      return ret;
    },
    isEnableService: function(serviceId, checkServiceId){
      return (serviceId & checkServiceId) == checkServiceId
    },
    getRequestComponent: function(serviceId) {
      var res = ""

      switch (parseInt(serviceId)) {
        case service.hst:
          res = requestComponent.hst;
          break;
        case service.psg:
          res = requestComponent.psg;
          break;
        case service.cpap:
          res = requestComponent.cpap;
          break;
        default:
          break;
      }

      return res;
    },
    // 過去日チェック(文字列)：引数の日付文字列が過去日ならTRUE返却
    isPastday: function (targetDayStr) {
      if (!targetDayStr) return false
      var isPast = false
      var targetY = targetDayStr.split("/")[0];
      var targetM = targetDayStr.split("/")[1] - 1;
      var targetD = targetDayStr.split("/")[2];
      var targetDate = new Date(targetY, targetM, targetD);
      var today = new Date();
      var tYear = targetDate.getFullYear()
      var tMonth = targetDate.getMonth() + 1
      var tDate = targetDate.getDate()
      var year = today.getFullYear()
      var month = today.getMonth() + 1
      var day = today.getDate()
      if (tYear == year) {
        if (tMonth == month) {
          if (tDate < day) {
            isPast = true
          }
        } else {
          if (tMonth < month) {
            isPast = true
          }
        }
      } else {
        if (tYear < year) {
          isPast = true
        }
      }
      return isPast
    },
    // nヶ月以内か判定する：引数の日付文字列がnヶ月以内ならTRUE返却
    isSoon: function (targetDayStr, monthCount) {
      if (!targetDayStr) return false
      var isSoon = false
      var targetY = targetDayStr.split("/")[0];
      var targetM = targetDayStr.split("/")[1] - 1;
      var targetD = targetDayStr.split("/")[2];
      var targetDate = new Date(targetY, targetM, targetD);
      var today = new Date();
      var tYear = targetDate.getFullYear()
      var tMonth = targetDate.getMonth() + 1
      var tDate = targetDate.getDate()
      var year = today.getFullYear()
      var month = today.getMonth() + 1 + Number(monthCount)
      var day = today.getDate()
      if (tYear == year) {
        if (tMonth == month) {
          if (tDate <= day) {
            isSoon = true
          }
        } else {
          if (tMonth < month) {
            isSoon = true
          }
        }
      } else {
        if (tYear < year) {
          isSoon = true
        }
      }
      return isSoon
    },
    /**
     * バリデーションチェックライブラリ
     */
    selfMadeValidation: function (elements) {
      // 返却値の宣言
      var result = {
        isError: false,
        msg:""
      }
      // バリデーションチェック対象のループ
      for (var element of elements) {
        if (element.getAttribute("display") && element.getAttribute("display")=="false") {
          continue
        }
        var validate = element.getAttribute("validate")
        var validates = validate.split('|')
        element.style["border-color"] = "";
        if (element.validationMessage) {
          result.isError = true
          result.msg = result.msg + element.name + "は有効な値を入力してください。\n"
          element.style["border-color"] = "red";
          continue
        }
        validateLoop: 
        for (const val of validates) {
          // ケース毎のバリデーション(case追加で拡張可能)
          switch (val) {
            case "required":
              // 必須チェック
              if (element.value == "" || element.value == null) {
                result.isError = true
                result.msg = result.msg + element.name + "は必須項目です。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              } else {
                let target = element.value.replaceAll(" ", "").replaceAll("　", "")
                if (target.length == 0) {
                  result.isError = true
                  result.msg = result.msg + element.name + "は必須項目です。\n"
                  element.style["border-color"] = "red";
                  break validateLoop;
                }
              }
              break;
            case "numeric":
              // 半角数字チェック
              if (!element.value) {
                continue;
              }
              if (!(String(element.value).match(/^\d+$/))) {
                result.isError = true
                result.msg = result.msg + element.name + "は半角数字で入力してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "numerichypen":
              // 半角数字+「-」チェック
              if (!element.value) {
                continue;
              }
              if (!(String(element.value).match(/^[\d-]+$/))) {
                result.isError = true
                result.msg = result.msg + element.name + "は半角数字及び「-」で入力してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "postCode":
              // 半角数字+「-」チェック
              if (!element.value) {
                continue;
              }
              if (!(String(element.value).match(/^\d{7}$/)) &&
                !(String(element.value).match(/^\d{3}-\d{4}$/))) {
                result.isError = true
                result.msg = result.msg + element.name + "は「半角数字(7桁)」または「半角数字(3桁)-半角数字(4桁)」で入力してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "double":
              // ダブル型チェック(半角数字と小数点)
              if (!element.value) {
                continue;
              }
              var regexp = new RegExp(/^(([1-9][0-9]{0,2})|0)(\.[0-9]{1,1})?$/);
              if (!regexp.test(String(element.value))) {
                result.isError = true
                result.msg = result.msg + element.name + "は整数部3桁小数第1位まで(半角数字,小数点のみ)で入力してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "mail":
              // メールアドレス形式チェック
              if (!element.value) {
                continue;
              }
              var regexp = new RegExp(/[^\x01-\x7E\uFF61-\uFF9F]/);
              var value = String(element.value)
              if (!validator.isEmail(value)) {
                result.isError = true
                result.isFormatError = true;
                result.msg = result.msg + element.name + "は形式が誤っています。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              if(regexp.test(value)){
                //全角文字
                result.isError = true
                result.isFormatError = true;
                result.msg = result.msg + element.name + "に全角文字が含まれています。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "mail_none":
              // メールアドレス形式(or"なし")チェック
              if (!element.value || element.value=="なし") {
                continue;
              }
              var regexp = new RegExp(/^([A-Za-z0-9]{1}[\+A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,})$/);
              if (!regexp.test(String(element.value))) {
                result.isError = true
                result.msg = result.msg + element.name + "は形式が誤っています。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "date":
              if (!element.value) {
                continue;
              }
              // 日付として有効かチェック
              if (!element.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                result.isError = true
                result.msg = result.msg + element.name + "は日付として有効ではありません。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              var y = element.value.split("-")[0];
              var m = element.value.split("-")[1] - 1;
              var d = element.value.split("-")[2];
              var date = new Date(y, m, d);
              if (date.getFullYear() != y || date.getMonth() != m || date.getDate() != d) {
                result.isError = true
                result.msg = result.msg + element.name + "は日付として有効ではありません。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "month":
              if (!element.value) {
                continue;
              }
              // 日付として有効かチェック
              if (!element.value.match(/^\d{4}-\d{2}$/)) {
                result.isError = true
                result.msg = result.msg + element.name + "は日付として有効ではありません。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              var y = element.value.split("-")[0];
              var m = element.value.split("-")[1] - 1;
              var date = new Date(y, m);
              if (date.getFullYear() != y || date.getMonth() != m) {
                result.isError = true
                result.msg = result.msg + element.name + "は日付として有効ではありません。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "userId":
              var targetStr = element.value
              if (!targetStr) {
                continue;
              }
              // ユーザーID形式チェック
              // 6文字以上20文字以内。
              if (targetStr.length < 6 || targetStr.length > 20) {
                result.isError = true
                result.isFormatError = true;
                result.msg = result.msg + element.name + "は6-20文字以内で入力してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              // IDは6文字以上20文字以内。英文字・数字・記号のうち2種類を含めてください。大文字・小文字は区別しません。記号は”-”ハイフン又は”_”アンダースコアを使用してください。
              if (targetStr.match(/[^-_a-zA-Z0-9]/i)) {
                result.isError = true
                result.isFormatError = true;
                result.msg = result.msg + element.name + "の形式が誤っています。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              } 
              var matchCnt = 0
              var regExpList = [/[a-z]/i, /\d/i, /[-_]/i]
              for (var reg of regExpList) {
                if (matchCnt >= 2) {
                  break;
                }
                if (targetStr.match(reg)) {
                  matchCnt ++
                }
              }
              if (matchCnt < 2) {
                result.isError = true
                result.isFormatError = true;
                result.msg = result.msg + element.name + "の形式が誤っています。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            case "kana":
              if (!element.value) {
                continue;
              }
              //カナチェック
              var regexp = new RegExp(/^[ァ-ヶーｦ-ﾟ 　]*$/);
              if (!regexp.test(String(element.value))) {
                result.isError = true
                result.msg = result.msg + element.name + "はカタカナのみ使用してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            
            case "birthDay":
              if (!element.value) {
                continue;
              }
              // 日付として有効かチェック
              if (!element.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                result.isError = true
                result.msg = result.msg + element.name + "は日付として有効ではありません。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              var y = element.value.split("-")[0];
              var m = element.value.split("-")[1] - 1;
              var d = element.value.split("-")[2];
              var targetDate = new Date(y, m, d);
              var today = new Date();
              var tYear = targetDate.getFullYear()
              var tMonth = targetDate.getMonth()+1
              var tDate = targetDate.getDate()
              var year = today.getFullYear()
              var month = today.getMonth() + 1
              var day = today.getDate()
              if (tYear == year) {
                if (tMonth == month) {
                  if (tDate > day) {
                    result.isError = true
                    result.msg = result.msg + element.name + "に未来日は指定できません。\n"
                    element.style["border-color"] = "red";
                    break validateLoop;
                  }
                } else {
                  if (tMonth > month) {
                    result.isError = true
                    result.msg = result.msg + element.name + "に未来日は指定できません。\n"
                    element.style["border-color"] = "red";
                    break validateLoop;
                  }
                }
              } else {
                if (tYear > year) {
                  result.isError = true
                  result.msg = result.msg + element.name + "に未来日は指定できません。\n"
                  element.style["border-color"] = "red";
                  break validateLoop;
                }
              }
              break;
            
            case "notPastDay":
              if (!element.value) {
                continue;
              }
              // 日付として有効かチェック
              if (!element.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                result.isError = true
                result.msg = result.msg + element.name + "は日付として有効ではありません。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              var y = element.value.split("-")[0];
              var m = element.value.split("-")[1] - 1;
              var d = element.value.split("-")[2];
              var targetDate = new Date(y, m, d);
              var today = new Date();
              var tYear = targetDate.getFullYear()
              var tMonth = targetDate.getMonth() + 1
              var tDate = targetDate.getDate()
              var year = today.getFullYear()
              var month = today.getMonth() + 1
              var day = today.getDate()
              if (tYear == year) {
                if (tMonth == month) {
                  if (tDate < day) {
                    result.isError = true
                    result.msg = result.msg + element.name + "に過去日は指定できません。\n"
                    element.style["border-color"] = "red";
                    break validateLoop;
                  }
                } else {
                  if (tMonth < month) {
                    result.isError = true
                    result.msg = result.msg + element.name + "に過去日は指定できません。\n"
                    element.style["border-color"] = "red";
                    break validateLoop;
                  }
                }
              } else {
                if (tYear < year) {
                  result.isError = true
                  result.msg = result.msg + element.name + "に過去日は指定できません。\n"
                  element.style["border-color"] = "red";
                  break validateLoop;
                }
              }
              break;
            
            case "patientName":
              // 患者名の入力チェック
              // 半角カナ、数字、半角スペース禁止
              if (!element.value) {
                continue;
              }
              var regexp = new RegExp(/^[^0-9ｦ-ﾟ ]*$/);
              if (!regexp.test(String(element.value))) {
                result.isError = true
                result.msg = result.msg + element.name + "は「半角カナ」「数字」「半角スペース」以外で入力してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;
            
            case "patientNameKana":
              // 患者名(カナ)の入力チェック
              // 全角カナのみ
              if (!element.value) {
                continue;
              }
              var regexp = new RegExp(/^[ァ-ヴー]*$/);
              if (!regexp.test(String(element.value))) {
                result.isError = true
                result.msg = result.msg + element.name + "は全角カナのみ使用してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;

            case "max50":
              // 最大桁数チェック(50桁)
              if (!element.value) {
                continue;
              }
              if (element.value.length > 50) {
                result.isError = true
                result.msg = result.msg + element.name + "は50文字以内で入力してください。\n"
                element.style["border-color"] = "red";
                break validateLoop;
              }
              break;

            case "radioRequire":
              // 必須チェック
              let isError = true
              let bRadioElementCollection = element.children
              for(let bRadioElement of bRadioElementCollection){
                let inputElement = bRadioElement.getElementsByTagName('input')
                if(inputElement[0].checked){
                  isError = false
                }
              }
              if (isError == true) {
                result.isError = true                
                result.msg = result.msg + element.getAttribute("name") + "は必須項目です。\n" 
              }

              //チェック結果に応じてborder-colorを変更
              for(let bRadioElement of bRadioElementCollection){
                let checkElement = bRadioElement.getElementsByClassName("check")
                if(isError){
                  checkElement[0].style["border-color"] = "red"
                } else {
                  checkElement[0].style["border-color"] = ""
                }
              }
              break validateLoop;
          }
        }
      }
      return result
    },
    /**
     * mailtoの特殊文字エスケープ処理
     * @param {*} string 
     */
		escapeStringForMailTo(string) {
      let escapeChars = {
        '&': '＆',
      };
      return string.replace(/[&]/g, function(target) {
        return escapeChars[target];
      });
    },
    /**
     * 文字コード取得
     * @param {}} file 
     */
    async getEncoding(file) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(file)
      var buffer = await new Promise(resolve => reader.onload = () => resolve(reader.result));
      reader.abort();
      var encode = encoding.detect(new Uint8Array(buffer))
      return encode;
    },
    async sendError(err, data) {
      try {
        console.log(err)
        var body = {
          message: err ? err : "",
          data: data ? JSON.stringify(data, null, 2) : ""
        }

        var client = await this.getSwaggerClient(body)
        await client.apis.apiCommon.loggingErrorPOST({
          body: body
        })
      } catch (ex) {
        console.log(ex)
      }
    },
    /**
     * 企業検診 ステータス変換
     * @param {*} value 
     * @returns 
     */
    convStatus: function(value){
      let ret = "";
      if (value == requestStatus.inspectionRequest){//検査依頼中
        return "申込み"
      } else if (value == requestStatus.deviceReady){//機器準備中
        return "検査受付"
      } else if (value == requestStatus.shippingReady){//出荷準備中
        return "機器準備"
      } else if (value == requestStatus.inspenction){//検査中
        return "機器出荷"
      } else if (value == requestStatus.deviceReturn){//機器受領中
        return "機器受領"
      } else if (value == requestStatus.analysisForwarding){//解析依頼中
        return "解析依頼"
      } else if (value == requestStatus.analysisRequest){//解析依頼中
        return "申込み"
      } else if (value == requestStatus.analysis){//解析中
        return "解析受付"
      } else if (value == requestStatus.resultComfirm){//結果確認中
        return "判定"
      } else if (value == requestStatus.resultSendReady){//結果送付待
        return "結果送付待"
      } else if (value == requestStatus.kawagoeAcceptance){//川越受付中
        return "検診受付"
      } else if (value == requestStatus.jugdmentRequest){//判定依頼中
        return "判定依頼"
      } else if (value == requestStatus.completion){//完了
        return "結果送付"
      } else if (value == requestStatus.salesAppropriation){//売上計上中
        return "N/A"
      } else if (value == requestStatus.completionAppropriation){//完了（計上済）
        return "売上計上"
      } else if (value == requestStatus.reInspection){//再検査調整中
        return "再検査調整"
      } else if (value == requestStatus.cancel){//キャンセル
        return "キャンセル"
      } else if (value == requestStatus.replaceFile){//ファイル差し替え依頼
        return "データ差換え依頼"
      } else if (value == requestStatus.replaceFileFinish){//ファイル差し替え実施
        return "データ差換え実施"
      } else if (value == requestStatus.approvalRejecte){//承認却下
        return "却下"
      }else if (value == requestStatus.replaceReportFile){//完了後解析ファイル差替
        return "結果差替"
      }else if (value == requestStatus.replaceReportFileapproval){//完了後後差替ファイル承認
        return "結果差替承認"
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/mixin.js